@if (data$ | async; as data) {
  <div class="mb-6 rounded-sm border border-blue-300 bg-blue-100 p-4">
    Zmiana adresu rozliczeniowego będzie miała zastosowanie od przyszłej edycji.
  </div>

  <app-alerts />

  <app-public-subscription-billing-address-form
    [data]="data"
    [pending]="pending()"
    (cancelClickEvent)="handleCancelClickEvent()"
    (submitClickEvent)="handleSubmitClickEvent($event)" />
} @else {
  <app-spinner-filled />
}
